<template>
  <div class="space-y-8">
    <SectionHeader :title="__('FAQ')">
      <template #icon>
        <Icon class="text-3xl text-primary" name="quiz" is-filled />
      </template>
      <template v-if="canEdit" #button>
        <div class="ml-auto">
          <Button
            class="flex items-center gap-1.5"
            variant="ghost"
            @click="
              isEditing ? handleCancelButtonClick() : handleEditButtonClick()
            "
          >
            <Icon class="text-lg" :name="isEditing ? 'close' : 'edit'" />
            <span>{{ isEditing ? __('Cancel') : __('Edit') }}</span>
          </Button>
        </div>
      </template>
    </SectionHeader>

    <FaqEdit
      v-if="isEditing"
      :data="data"
      :error-message="errorMessage"
      :config-general-single-company="configGeneralSingleCompany"
      @cancel="handleCancelButtonClick"
      @save="handleSaveButtonClick"
    />
    <FaqView v-else :data="data" />
  </div>
</template>

<script setup>
  import { ref } from 'vue';
  import { Button } from '@/components/block/button';
  import { Icon } from '@/components/block/icon';
  import { SectionHeader } from '@/pages/components/section-header';
  import { FaqEdit } from './components/faq-edit';
  import { FaqView } from './components/faq-view';
import { __ } from '../../../../../helpers';

  const props = defineProps({
    data: {
      type: Array,
      required: true
    },
    errorMessage: {
      type: String,
      default: ''
    },
    canEdit: {
      type: Boolean,
      required: true
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    configGeneralSingleCompany: {
      type: Number,
      required: true
    }
  });

  const emits = defineEmits(['update-is-editing']);

  const data = ref(JSON.parse(JSON.stringify(props.data)));

  function handleEditButtonClick() {
    emits('update-is-editing', true);
  }

  function handleCancelButtonClick() {
    emits('update-is-editing', false);
  }

  function handleSaveButtonClick(value) {
    data.value = value;

    emits('update-is-editing', false);
  }
</script>
